import ProfileMenuCard from './ProfileMenuCard';

export default ProfileMenuCard;
